import className from 'classnames';
import React, { useEffect, useState } from 'react';

import PageStore from '@/stores/page';

import doLog from '@/common/log';
import isNodeServer from '@/utils/isNodeServer';

// 解决点击触发滚动拦截
let selected = false;
export default function SubMenu() {
  const subMenu = PageStore(state => state.subMenu);
  if (isNodeServer()) return null;
  const [activeId, setActiveId] = useState('');
  let timeOut: NodeJS.Timeout | null = null;

  useEffect(() => {
    const handleScroll = () => {
      const contentElements = document.querySelectorAll('.layout-left h3.att-title');
      const menuItems = document.querySelectorAll('.sub-menu-layout .sub-menu-item');

      contentElements.forEach((element, index) => {
        const rect = element.getBoundingClientRect();
        if ((menuItems[index] as any)?.dataset.id) {
          if (selected) return false;
          if (rect.top >= 0 && rect.bottom <= window.innerHeight && rect.top < 150) {
            if (timeOut) {
              clearTimeout(timeOut);
            }
            timeOut = setTimeout(() => {
              setActiveId((menuItems[index] as any).dataset.id);
            }, 50);
          }
        }
      });
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div className="sub-menu-layout">
      {subMenu.map(i => (
        <a
          className={className({
            'sub-menu-item': true,
            active: i.id === activeId,
          })}
          href="#"
          data-id={i.id}
          onClick={e => {
            e.preventDefault();
            selected = true;
            const element = document.getElementById(i.id);
            if (element) {
              const elementTop = element.getBoundingClientRect().top + window.pageYOffset;
              window.scrollTo({
                top: elementTop - 140,
                behavior: 'smooth',
              });
            }
            doLog('/sc.details.navigation', `type=${i.id}`);
            setActiveId(i.id);
            setTimeout(() => {
              selected = false;
            }, 2 * 1000);
          }}
        >
          {i.text}
        </a>
      ))}
    </div>
  );
}
